import { Alert, Button, Checkbox } from 'antd';
import { useState } from 'react';

interface RecoveryCodesRevealProps {
  codes: string[];
  onDone: () => void;
}

/** Shown exactly once, when the account's first second factor is turned on — there is no "view recovery codes" screen afterwards. */
export function RecoveryCodesReveal({ codes, onDone }: RecoveryCodesRevealProps) {
  const [confirmed, setConfirmed] = useState(false);

  return (
    <div className="rounded-lg border border-line bg-surface p-6">
      <h2 className="text-base font-semibold text-fg">Save your recovery codes</h2>
      <Alert
        className="mt-3"
        type="warning"
        showIcon
        title="These are shown only once. Store them somewhere safe — each one signs you in a single time if you can't get a code from your authenticator app or email."
      />
      <ul className="mt-5 grid grid-cols-2 gap-2 font-mono text-sm text-fg">
        {codes.map((code) => (
          <li key={code} className="rounded-md bg-page px-3 py-2">
            {code}
          </li>
        ))}
      </ul>
      <Checkbox className="mt-6" checked={confirmed} onChange={(e) => setConfirmed(e.target.checked)}>
        I've saved these recovery codes
      </Checkbox>
      <div className="mt-4">
        <Button type="primary" disabled={!confirmed} onClick={onDone}>
          Done
        </Button>
      </div>
    </div>
  );
}
